import { Box } from "@mui/material"
import { NavbarInvitado } from "./components/navbarInvitado"

export const InvitadoLayout = ({children}:any) =>{
    return(
        <>
        <NavbarInvitado/>
        <Box
        component="main"
        sx={{
          width:"100%",
          mt: "3.5rem",
          flexGrow: 1,
          p: 3,
        }}
      >
        {children}
      </Box>  
    </>
    )
}